module.exports = __webpack_public_path__ + "static/media/video-bg.3c70cf97.jpg";